import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    label: {
      fontSize: 14,
    },
  }),
);
